import {
  DELETE_FIELD_FORCE,
  ENALBE_DISABLE_FIELD_FORCE,
  FIELD_FORCE_DETAIL,
  FIELD_FORCE_LIST,
  EDIT_FIELD_FORCE,
  CREATE_FIELD_FORCE,
  DESIGNATION_LIST,
  REPORTING_MANAGER_LIST,
  HEAD_QUATERS_LIST,
  FIELD_FORCE_VERSION_LIST,
  FIELD_FORCE_VERSION_DETAIL,
  FETCH_DESIGNATION_LIST,
  FETCH_DESIGNATION_DETAIL,
  FIELD_FORCE_DESIGNATION_CREATE,
  FIELD_FORCE_DESIGNATION_DELETE,
  FIELD_FORCE_DESIGNATION_EDIT,
  FIELD_FORCE_DESIGNATION_VERSION_LIST,
  FIELD_FORCE_DESIGNATION_VERSION_DETAIL,
  LINK_EMP_LIST,
  LINK_EMPLOYEE,
  FIELD_FORCE_HEADQUARTER_LIST,
  FIELD_FORCE_HEADQUARTER_DETAIL,
  FIELD_FORCE_HEADQUARTER_CREATE,
  FIELD_FORCE_HEADQUARTER_EDIT,
  FIELD_FORCE_HEADQUARTER_VERSION_LIST,
  FIELD_FORCE_HEADQUARTER_VERSION_DETAIL,
  ENABLE_DISABLE_HEADQUARTER,
  FIELD_FORCE_HEADQUARTER_DELETE,
  FIELD_FORCE_ADMIN_DETAIL,
  FIELD_FORCE_ADMIN_VERIFY_DETAIL,
  FIELD_FORCE_ADMIN_EDIT_DETAIL,
  REPORT_DESIGNATION_LIST,
  FIELD_FORCE_ADMIN_OVERRIDE,
  SUBORDINATES_LIST,
  REPORTING_FIELD_FORCE_LIST,
  UPDATE_SUBORDINATES_REPORTING_MANAGER,
  FF_CUSTOMERS_LIST,
  UPDATE_CUSTOMERS_REPORTING_MANAGER,
} from "./types";

export const fieldForceUserList = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceDetail = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const fieldForceDelete = (id, onSuccess, onError) => {
  return {
    type: DELETE_FIELD_FORCE,
    id,
    onSuccess,
    onError,
  };
};

export const fieldForceEnableDisable = (id, onSuccess, onError) => {
  return {
    type: ENALBE_DISABLE_FIELD_FORCE,
    id,
    onSuccess,
    onError,
  };
};

export const fieldForceUserCreate = (data, onSuccess, onError) => {
  return {
    type: CREATE_FIELD_FORCE,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceUserEdit = (data, onSuccess, onError) => {
  return {
    type: EDIT_FIELD_FORCE,
    data,
    onSuccess,
    onError,
  };
};

export const designationList = (onSuccess, onError) => {
  return {
    type: DESIGNATION_LIST,
    onSuccess,
    onError,
  };
};

export const reportingManagerList = (data, onSuccess, onError) => {
  return {
    type: REPORTING_MANAGER_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const headQuaterList = (onSuccess, onError) => {
  return {
    type: HEAD_QUATERS_LIST,
    onSuccess,
    onError,
  };
};

export const fieldForceUserVersionList = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceFetchDesignationList = (data, onSuccess, onError) => {
  return {
    type: FETCH_DESIGNATION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceUserVersionDetail = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const fieldForceFetchDesignationDetail = (id, onSuccess, onError) => {
  return {
    type: FETCH_DESIGNATION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const createFieldForceDesignation = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_DESIGNATION_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const editFieldForceDesignation = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_DESIGNATION_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const deleteFieldForceDesignation = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_DESIGNATION_DELETE,
    id,
    onSuccess,
    onError,
  };
};

export const fieldForceDesignationVersionList = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_DESIGNATION_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceDesignationVersionDetail = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_DESIGNATION_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const linkEmpList = (onSuccess, onError) => {
  return {
    type: LINK_EMP_LIST,
    onSuccess,
    onError,
  };
};

export const linkEmployee = (data, onSuccess, onError) => {
  return {
    type: LINK_EMPLOYEE,
    data,
    onSuccess,
    onError,
  };
};

export const fieldForceHeadQuarterList = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const fieldForceFetchHeadQuarterDetail = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_DETAIL,
    id,
    onSuccess,
    onError,
  };
};
export const fieldForceHeadQuarterCreate = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const fieldForceHeadQuarterEdit = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const fieldForceHeadQuarterVersionList = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const fieldForceHeadQuarterVersionDetail = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};
export const enableDisableHeadQuarter = (id, onSuccess, onError) => {
  return {
    type: ENABLE_DISABLE_HEADQUARTER,
    id,
    onSuccess,
    onError,
  };
};
export const fieldForceHeadQuarterDelete = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_HEADQUARTER_DELETE,
    id,
    onSuccess,
    onError,
  };
};

export const fieldForceAdminDetail = (onSuccess, onError) => {
  return {
    type: FIELD_FORCE_ADMIN_DETAIL,
    onSuccess,
    onError,
  };
};
export const fieldForceAdminOverride = (onSuccess, onError) => {
  return {
    type: FIELD_FORCE_ADMIN_OVERRIDE,
    onSuccess,
    onError,
  };
};
export const fieldForceAdminVerifyDetail = (id, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_ADMIN_VERIFY_DETAIL,
    id,
    onSuccess,
    onError,
  };
};
export const fieldForceAdminEditDetail = (data, onSuccess, onError) => {
  return {
    type: FIELD_FORCE_ADMIN_EDIT_DETAIL,
    data,
    onSuccess,
    onError,
  };
};
export const reportingDesignationList = (data, onSuccess, onError) => {
  return {
    type: REPORT_DESIGNATION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const subordinatesList = (data, onSuccess, onError) => {
  return {
    type: SUBORDINATES_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const reportingFFList = (data, onSuccess, onError) => {
  return {
    type: REPORTING_FIELD_FORCE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const updateSubordinatesRM = (data, onSuccess, onError) => {
  return {
    type: UPDATE_SUBORDINATES_REPORTING_MANAGER,
    data,
    onSuccess,
    onError,
  };
};

export const updateCustomersRM = (data, onSuccess, onError) => {
  return {
    type: UPDATE_CUSTOMERS_REPORTING_MANAGER,
    data,
    onSuccess,
    onError,
  };
};

export const FFCustomersList = (data, onSuccess, onError) => {
  return {
    type: FF_CUSTOMERS_LIST,
    data,
    onSuccess,
    onError,
  };
};
